import Button from 'react-bootstrap/Button'
import {Form} from 'react-bootstrap-formik'
import {object, string} from 'yup'

export default function AuthLoginForm({onSubmit, onCancel}) {
  const validationSchema = object({
    email: string().email().required(),
    password: string().required()
  })

  return (
    <Form initialValues={{}} validationSchema={validationSchema} onSubmit={onSubmit}>
      <div className="mb-3">
        <Form.Input label="Email" name="email" type="email" />
      </div>
      <div className="mb-3">
        <Form.Input label="Password" name="password" type="password" />
      </div>
      <div className="text-end">
        <Button variant="outline-secondary" onClick={onCancel} className="me-2">Cancel</Button>
        <Button type="submit">Sign In</Button>
      </div>
    </Form>
  )
}
